import { AuthRoutes } from '@/auth/mixins';

// @vue/component
export default {
  mixins: [
    AuthRoutes,
  ],
  props: {
    emailAddress: {
      type: String,
      default: '',
    },
  },
  created() {
    if (!this.emailAddress) {
      this.$router.replace(this.routes.passwordReset);
    }
  },
};
